import { rankingData } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            八卦热度榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            实时更新全网最受关注的八卦话题排行
          </p>
        </div>

        <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className={`flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate">
                  {item.title}
                </h3>
              </div>
              {item.tag && (
                <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-xs font-medium ${
                  item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              )}
              <div className="flex-shrink-0 flex items-center gap-1 text-xs text-foreground-500">
                <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'}`}></i>
                <span>{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}